import React from 'react';
import Img from 'gatsby-image';
import MultiResolutionImage from './MultiResolutionImage';
import Link from 'gatsby-link';

const ImageGrid = ({ prefix, images }) => {
  return (
    <section className="section is-image-grid">
      <div className="container">
        <div className="columns is-mobile is-multiline">
          {images.map((image, index) => {
            return (
              <div
                className="column is-3-tablet is-6-mobile"
                key={`${prefix}-${index}`}
              >
                <Link
                  to={`/${image.link.slug}`}
                  title={`${image.link.title}`}
                  className="is-expanding-link"
                >
                  <MultiResolutionImage
                    image={image.image}
                    style={{ height: 'auto' }}
                  />
                </Link>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default ImageGrid;



// WEBPACK FOOTER //
// ./src/components/ImageGrid.js